import React from 'react'
import { bindActionCreators } from 'redux'
import {browserHistory}  from 'react-router'
import { connect } from 'react-redux'
import * as liveroomSetAct from '../../actions/liveroomSettingLecture'
import {
    PanelBody, MediaBox, MediaBoxTitle, MediaBoxDescription, PanelFooter, Panel,
    Dialog, ActionSheet, LoadMore
} from 'react-weui'
import { fixBackContentEmpty } from '../../utils'
import { LectureListMoveChannelDialog, ListEmpty, SearchEmpty } from '../../components/liveroomLecturer'
import { WKVisible, InfiniteScroll } from '../../components'
import yxImg from '../../images/detail_title_yx.png'
import { TimeStream, renderMoney } from '../../utils'


class LectureList extends React.Component {
    constructor(props) {
        super(props)
        this.relayMenu = [{
            label: '数据分析',
            onClick: () => {
                this.props.setIsLecMenuShow(false)
                setTimeout(() => {
                    location.assign(`/lecture/${this.props.currentLecture.id}/analysis`)
                }, 300)
            }
        },{
            label: <span style={{color:'#e64340'}}>删除</span>,
            onClick: () => this.onClickDelLecture()
        }]
        this.menu = [{
            label: '移入专栏',
            onClick: () => this.onClickMoveToChannel()
        }, {
            label: '数据分析',
            onClick: () => {
                this.props.setIsLecMenuShow(false)
                setTimeout(() => {
                    location.assign(`/lecture/${this.props.currentLecture.id}/analysis`)
                }, 300)
            }
        },{
            label: <span style={{color:'#e64340'}}>删除</span>,
            onClick: () => this.onClickDelLecture()
        }]
    }
    componentDidMount() {
        this.props.fetchLectures(this.props.liveroomId, {
            keyword: this.props.lectureKeyword,
            offset: 0,
        })
        fixBackContentEmpty()
    }
    onClickOpera(item) {
        this.props.setCurrentLecture(item)
        this.props.setIsLecMenuShow(true)
    }
    getLectureMode(item) {
        if (item.image_mode === 'ppt') {
            return 'PPT'
        }
        switch (item.image_mode) {
            case 'audio':
                return '音频'
            case 'video':
                return '视频'
            default:
                return ''
        }
    }
    renderMoney(item) {
        if (item.lecture_type === 'password_lecture') return '加密'
        return item.money ? `￥${renderMoney(item.money)}` : ''
    }
    onClickDelLecture() {
        this.props.setIsLecMenuShow(false)
        // this.props.setIsShowDelLecture(true)
        this.props.postCheckDelLecture(this.props.currentLecture.id)
    }
    onClickDelLectureOk() {
        this.props.delLecture(this.props.currentLecture.id, this.props.liveroomId, this.props.lectureKeyword)
        this.props.setIsShowDelLecture(false)
        this.props.setIsLecMenuShow(false)
    }
    onClickMoveToChannel() {
        this.props.setIsLecMenuShow(false)
        if (this.props.currentLecture.is_relay) {
            this.props.setInfo({ infoText: '该课程为转载课程，不能移入', isInfo: true })
            setTimeout(() => {
                this.props.setInfo({ infoText: '', isInfo: false })
            }, 2000)
            return
        }
        this.props.fetchLecture(this.props.currentLecture.id)
        this.props.setIsShowMoveChannels(true)
        this.props.fetchChannels(this.props.liveroomId)
    }
    handleTouchBottom () {
        this.props.fetchLectures(this.props.liveroomId, {
            keyword: this.props.lectureKeyword,
            offset: this.props.lecturesOffset,
            preLectures: this.props.lectures,
        })
    }
    render() {
        const list = this.props.lectures
        // const list = []
        if (list === null) {
            return <LoadMore loading>正在加载</LoadMore>
        }
        return (
            <div>
                {
                    list.map(item => {
                        return (
                            <Panel key={item.id}>
                                <PanelBody onClick={e => this.props.pushPath('lecture', item.id)}>
                                    <MediaBox type="text">
                                        <MediaBoxTitle>
                                            <WKVisible tag='span' create={item.is_preffered}>
                                                <img className='yx-img' src={yxImg} alt="优选" />
                                            </WKVisible>
                                            <WKVisible create={this.getLectureMode(item)} className='v-label'>
                                                <div className="lecture-tag">
                                                    {this.getLectureMode(item)}
                                                </div>
                                            </WKVisible>
                                            <span className="title-text">{item.is_relay ? '【转】' : ''}{item.name}</span>
                                        </MediaBoxTitle>
                                        <MediaBoxDescription>
                                            <span className='weui-flex' style={{ width: '100%'}}>
                                                <span className='weui-flex__item subtitle'>
                                                    {(item.lecture_mode !== 'video' && item.lecture_mode !== 'audio') &&
                                                    <span className="placeholder">{TimeStream(item.start_timestamp)}</span>
                                                    }
                                                    <span className="people-count">{item.popular}人气</span>
                                                </span>
                                                <span className='text-right weui-flex__item'>
                                                    <span className="red">{this.renderMoney(item)}</span>
                                                </span>
                                            </span>
                                        </MediaBoxDescription>
                                    </MediaBox>
                                </PanelBody>
                                <PanelFooter>
                                    <div className="opera-btn" onClick={e => this.onClickOpera(item)}>操作</div>
                                </PanelFooter>
                            </Panel>
                        )
                    })
                }

                <WKVisible create={this.props.isLecturesEmpty}>
                    <ListEmpty type='lecture' />
                </WKVisible>

                <WKVisible show={this.props.isSearchEmpty}>
                    <SearchEmpty />
                </WKVisible>

                <WKVisible show={!this.props.isScrollKill}>
                    <WKVisible show={this.props.isScrollStop}>
                        <LoadMore loading>正在加载</LoadMore>
                    </WKVisible>
                </WKVisible>

                <Dialog type="ios" title='温馨提示' show={this.props.isShowDelLectureConfirm} buttons={[{
                    label: '删除',
                    type: 'default',
                    onClick: () => this.onClickDelLectureOk(),
                }, {
                    label: '暂不删除',
                    onClick: () => this.props.setIsShowDelLecture(false),
                }]}>
                    是否确认删除课程，课程若被删除，将不可再恢复
                </Dialog>

                <ActionSheet
                    menus={this.props.currentLecture.is_relay ? this.relayMenu : this.menu}
                    actions={[{
                        label: '取消',
                        onClick: () => {
                            this.props.setIsLecMenuShow(false)
                            this.props.setIsChaMenuShow(false)
                        }
                    }]}
                    show={this.props.lectureMenuShow}
                    type="ios"
                    onRequestClose={e => this.props.setIsLecMenuShow(false)}
                />

                <LectureListMoveChannelDialog liveroomId={this.props.liveroomId} />

                <InfiniteScroll
                    onTouchBottom={() => this.handleTouchBottom()}
                    isStop={this.props.isScrollStop}
                    distance={300}
                    isKill={this.props.isScrollKill}
                />
            </div>
        )
    }
}

export default connect(state => ({
    lectures: state.liveroomSettingLecture.lectures,
    lectureMenuShow: state.liveroomSettingLecture.lectureMenuShow,
    currentLecture: state.liveroomSettingLecture.currentLecture,
    isShowDelLectureConfirm: state.liveroomSettingLecture.isShowDelLectureConfirm,
    isShowMoveChannels: state.liveroomSettingLecture.isShowMoveChannels,
    lectureKeyword: state.liveroomSettingLecture.lectureKeyword,
    isScrollStop: state.liveroomSettingLecture.isScrollStop,
    isScrollKill: state.liveroomSettingLecture.isScrollKill,
    lecturesOffset: state.liveroomSettingLecture.lecturesOffset,
    isSearchEmpty: state.liveroomSettingLecture.isSearchEmpty,
    isLecturesEmpty: state.liveroomSettingLecture.isLecturesEmpty,
}), dispatch => bindActionCreators({ ...liveroomSetAct }, dispatch))(LectureList)



// WEBPACK FOOTER //
// ./src/components/liveroomLecturer/LectureList.js